module.exports = __webpack_public_path__ + "static/media/Downloadicon.2928664f.svg";